export default "__VITE_ASSET__Fti8gFzt__"